import { AddIcon } from "@chakra-ui/icons";
import {
  Button, Checkbox,
  FormControl,
  FormHelperText,
  FormLabel, Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay, Stack, Text,
  useDisclosure, useToast
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import {useMutation, useQueryClient} from "react-query";

import { postUserAcceptsTerms } from "../../shared/Api";
import {errorToast, successToast} from "../../shared/helper/ToastHelper";
import {useAuthentication} from "../../shared/hooks/AuthenticationProvider";
import {useFont} from "../../shared/hooks/FontProvider";
import {useTheme} from "../../shared/hooks/ThemeProvider";
import {userKeys} from "../../shared/QueryKeys";

type TermsAndConditionsProps = {
  acceptsTC: boolean;
  setAcceptsTC: (newState: boolean) => void;
  textColor?: string;
  readonly?: boolean;
  stayLogged?: boolean;
};

const TermsAndConditionsModal = (props: TermsAndConditionsProps) => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const authentication = useAuthentication();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const theme = useTheme().theme;
  const font = useFont().font;

  const textColor = props.textColor !== undefined ? props.textColor : theme.TEXT_SECONDARY;

  const updateAcceptTerms = useMutation(({acceptsTC }: any) =>
      postUserAcceptsTerms(acceptsTC),
    {
      onSuccess: (data, variables) => {
        props.setAcceptsTC(variables.acceptsTC);
        onClose();
        if (!variables.acceptsTC && !props.stayLogged)
            authentication.logoutMutation?.mutate(null);
        return queryClient.invalidateQueries(userKeys.acceptTerms());
      },
      onError: () => {
        errorToast(toast, "Ocurrió un error en el servidor");
      },
    });

  return (
    <>{/*
      <Stack direction='row' marginTop="0.5em">
          <Checkbox minW="fit-content" colorScheme={theme.TEXT_SECONDARY}
                    onChange={ (e) => {e.preventDefault() }}
                    isChecked={props.acceptsTC}
                    defaultChecked={props.acceptsTC}>
          </Checkbox>
        <Text fontWeight={font.weight}
                  fontSize={font.h6}
         color={theme.TEXT_SECONDARY}>
         Acepto los <Link onClick={onOpen}><b>Términos y Condiciones</b></Link></Text>
         {/*isExternal Acepto los <Link href='https://pelex.ucr.ac.cr/pruebas2022/tyc.php' ><b>Términos y Condiciones</b></Link></Text>}
      </Stack>
      */
      }
      <Link onClick={onOpen}>
       <Stack direction='row' marginTop="0.5em" >
       <Checkbox minW="fit-content" colorScheme={textColor} id='acceptTC' iconColor={textColor}
                                                 onChange={ (e) => {e.preventDefault() }}
                                                 isChecked={props.acceptsTC}
                                                 defaultChecked={props.acceptsTC}>
                                       </Checkbox>
                                     <Text fontWeight={font.weight}
                                               fontSize={font.h6}
                                      color={textColor}>
                                      Acepto los <b>Términos y Condiciones</b></Text>
                                      </Stack>

      </Link>
      <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose} size={'3xl'}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Términos y Condiciones</ModalHeader>
          <ModalBody>
          { authentication.currentUserQuery?.data?.data?.uGroup!== undefined &&
              authentication.currentUserQuery?.data?.data?.uGroup==='SuficienciaLM1618' ? (
              <Text fontWeight={font.weight} textAlign='justify'>
            Este examen es propiedad intelectual del Proyecto de Evaluación en Lengua Extranjera (PELEx) de la Universidad de Costa Rica. Su contenido, en su totalidad o en partes, es confidencial y está protegido por políticas institucionales de uso y divulgación.
            <br/>Al iniciar esta prueba, usted acepta los siguientes términos y condiciones:
            <br/><b>1. Confidencialidad:</b> El contenido del examen, incluyendo sus ítems, materiales, instrucciones y respuestas, no será compartido ni entregado a las personas candidatas, ya sea de forma total o parcial, en ningún momento antes, durante o después de la administración de la prueba.
            <br/><b>2. Uso exclusivo:</b> Este instrumento ha sido diseñado exclusivamente para fines de evaluación dentro del marco del proyecto PELEx y no podrá ser reproducido, copiado, fotografiado ni distribuido bajo ninguna circunstancia.
            <br/>Al hacer clic en “Aceptar”, usted declara haber leído, comprendido y aceptado los términos y condiciones aquí establecidos. Si no está de acuerdo, cierre la plataforma en este momento.
            </Text>
            ) : (

              <Text fontWeight={font.weight} textAlign='justify'>
            Este examen es propiedad intelectual del Proyecto de Evaluación en Lengua Extranjera (PELEx) de la Universidad de Costa Rica. Su contenido, en su totalidad o en partes, es confidencial y está protegido por políticas institucionales de uso y divulgación.
            <br/>Al iniciar esta prueba, usted acepta los siguientes términos y condiciones:
            <br/><b>1. Confidencialidad:</b> El contenido del examen, incluyendo sus ítems, materiales, instrucciones y respuestas, no será compartido ni entregado a las personas candidatas, ya sea de forma total o parcial, en ningún momento antes, durante o después de la administración de la prueba.
            <br/><b>2. Inapelabilidad:</b> Los resultados del examen son definitivos e inapelables. No se ofrecerán revisiones individuales de ítems ni retroalimentación específica sobre respuestas correctas o incorrectas.
            <br/><b>3. Uso exclusivo:</b> Este instrumento ha sido diseñado exclusivamente para fines de evaluación dentro del marco del proyecto PELEx y no podrá ser reproducido, copiado, fotografiado ni distribuido bajo ninguna circunstancia.
            <br/>Al hacer clic en “Aceptar”, usted declara haber leído, comprendido y aceptado los términos y condiciones aquí establecidos. Si no está de acuerdo, cierre la plataforma en este momento.
            </Text>
                        )

          }

          </ModalBody>
          <ModalCloseButton />
          <ModalFooter>
            <Button
                colorScheme={theme.COLOR_SCHEME}
                type="submit"
                onClick={()=>{
                    if (!props.acceptsTC)
                        updateAcceptTerms.mutate({
                          acceptsTC: true
                          });
                    else
                        onClose();
                    } }>
              Aceptar
            </Button>
            {!props.readonly && <Button marginLeft='2em'
                colorScheme='red'
                type="submit"
                onClick={()=>{
                    updateAcceptTerms.mutate({
                      acceptsTC: false
                      });
                    } }>
              Rechazar
            </Button>}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default TermsAndConditionsModal;